import StromaHome from './StromaHome';

/**
 * Home (#182): the cold open — the work queue of #569: Needs you, your
 * objectives, this week, continue.
 */
export default function HomeView() {
  return <StromaHome />;
}
